import * as React from "react";
import { ArrowLeft } from "lucide-react";
import { cn } from "./lib/utils";
import { Button } from "./button";

type BackButtonProps = {
  label: string;
} & React.ComponentProps<typeof Button>;

/**
 * Canonical back control: an outline Button with a leading ArrowLeft. Pass the
 * localized label (e.g. i18n.t("common.back")) — shared ui/ components stay
 * i18n-free.
 */
export function BackButton({
  label,
  className,
  ...props
}: BackButtonProps): React.JSX.Element {
  return (
    <Button
      variant="outline"
      data-slot="back-button"
      className={cn(
        "flex items-center gap-2 border-foreground/15 text-foreground hover:bg-foreground/10",
        className,
      )}
      {...props}
    >
      <ArrowLeft className="h-4 w-4" />
      {label}
    </Button>
  );
}
